/**
 * Featured Lesson API client — Feb 2026 mid-month.
 *
 * Bridge feature between the retired free-user Community access and the
 * future Weekly-10 build. Admin pins one lesson; free users see it on
 * their dashboard, email it to themselves, and open a delivery page
 * with PDF + PPTX downloads and a CASL-clean opt-in toggle.
 */
import { api } from "./api";

// ---- Public (auth: signed-in user or delivery-token) ----------------
export async function fetchFeaturedLesson() {
  const { data } = await api.get("/featured-lesson");
  return data; // { pinned: bool, ...card }
}

export async function requestFeaturedLessonEmail(email) {
  const { data } = await api.post("/featured-lesson/email", { email });
  return data;
  // { ok, token, delivered_to, delivery_mode: "sent" | "dry_run", deliver_url? }
}

export async function fetchDeliveryPage(token) {
  const { data } = await api.get(
    `/featured-lesson/deliver/${encodeURIComponent(token)}`,
  );
  return data;
  // { token, expires_at, email, subscribed, activity_name, ... }
}

export async function toggleDeliveryOptIn(token, subscribe) {
  const { data } = await api.post(
    `/featured-lesson/deliver/${encodeURIComponent(token)}/optin`,
    { subscribe: !!subscribe },
  );
  return data; // { ok, subscribed, emailoctopus_synced, at }
}

export function deliveryPdfUrl(token) {
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return `${base}/api/featured-lesson/deliver/${encodeURIComponent(token)}/pdf`;
}

export function deliverySlidesUrl(token) {
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return `${base}/api/featured-lesson/deliver/${encodeURIComponent(token)}/slides`;
}

// ---- Admin ----------------------------------------------------------
export async function fetchFeaturedLessonAdmin() {
  const { data } = await api.get("/admin/featured-lesson");
  return data;
}

export async function fetchFeaturedLessonCandidates() {
  const { data } = await api.get("/admin/featured-lesson/candidates");
  return data; // { library: [...], community: [...] }
}

export async function pinFeaturedLesson(activityId) {
  const { data } = await api.post("/admin/featured-lesson", {
    activity_id: activityId,
  });
  return data;
}

export async function unpinFeaturedLesson() {
  const { data } = await api.delete("/admin/featured-lesson");
  return data;
}
